import { PropsWithChildren, ReactNode } from "react";

import twMerge from "@krea/customer-features/utils/tailwind-utils";

interface IBidsListTableProps {
  className?: string;
  thead?: ReactNode;
}

const BidsListTable = ({
  children,
  className,
  thead,
}: PropsWithChildren<IBidsListTableProps>) => {
  return (
    <table
      className={twMerge(
        "tw-w-full tw-border-separate tw-border-spacing-0 tw-table-auto",
        className,
      )}
    >
      {thead && (
        <thead className="tw-border tw-border-solid tw-border-white">
          <tr>
            <th className="tw-w-[16px] tw-min-w-[16px] tw-max-w-[16px]" />
            {thead}
            <th className="tw-w-[16px] tw-min-w-[16px] tw-max-w-[16px]" />
          </tr>
        </thead>
      )}

      {children && <tbody>{children}</tbody>}
    </table>
  );
};

export default BidsListTable;
